import { render } from "./added-admin.vue?vue&type=template&id=b2469ebe&scoped=true"
import script from "./added-admin.vue?vue&type=script&lang=js"
export * from "./added-admin.vue?vue&type=script&lang=js"

import "./added-admin.vue?vue&type=style&index=0&id=b2469ebe&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b2469ebe"]])

export default __exports__